import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Image, InputGroup, Badge, Dropdown, Card } from 'react-bootstrap';
import {
    FaSearch,
    FaPhone,
    FaVideo,
    FaUsers,
    FaUserFriends,
    FaEllipsisH,
    FaSmile,
    FaPaperclip,
    FaPaperPlane,
    FaDownload,
    FaEllipsisV,
    FaUser,
    FaThumbsUp,
    FaComment,
    FaAddressBook,
    FaCog,
    FaGlobe,
    FaMoon,
    FaBars,
    FaTimes,
    FaCalendarAlt,
    FaFilter,
    FaChevronLeft,
    FaChevronRight,
    FaHistory
} from 'react-icons/fa';
import GlobalMiniSidebar from './GlobalMiniSidebar';
import './ChatHistoryPage.css';

const ChatHistoryPage = () => {
    const [activeContact, setActiveContact] = useState('Patrick Hendricks');
    const [showSidebar, setShowSidebar] = useState(false);
    const [filterDate, setFilterDate] = useState('All time');
    const [currentDateRange, setCurrentDateRange] = useState('March 2025');
    const sidebarRef = useRef(null);
    const historyContainerRef = useRef(null);

    // Toggle sidebar for mobile view
    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    // Close sidebar when clicking outside on mobile
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (window.innerWidth < 768 && 
                sidebarRef.current && 
                !sidebarRef.current.contains(event.target) &&
                !event.target.closest('.menu-toggle')) {
                setShowSidebar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Check window size and adjust sidebar visibility
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setShowSidebar(false);
            } else {
                setShowSidebar(true);
            }
        };

        // Initial check
        handleResize();

        // Listen for window resize
        window.addEventListener('resize', handleResize);
        
        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Sample data for recent chats
    const recentChats = [
        {
            id: 1,
            name: 'Patrick Hendricks',
            image: '/assets/avatars/user-1.png',
            lastMessage: "Hey! there I'm available",
            time: '05 min',
            unread: false
        },
        {
            id: 2,
            name: 'Mark Messer',
            image: '/assets/avatars/user-5.png',
            lastMessage: 'Images',
            time: '12 min',
            unread: true,
            unreadCount: 2
        },
        {
            id: 3,
            name: 'General',
            image: '',
            initial: 'G',
            lastMessage: 'This theme is awesome!',
            time: '20 min',
            unread: false
        },
        {
            id: 4,
            name: 'Doris Brown',
            image: '/assets/avatars/user-2.png',
            lastMessage: 'Nice to meet you',
            time: '10:12 AM',
            unread: false
        },
        {
            id: 5,
            name: 'Designer',
            image: '',
            initial: 'D',
            lastMessage: 'Next meeting tomorrow 10:00AM',
            time: '12:01 PM',
            unread: true,
            unreadCount: 1
        },
        {
            id: 6,
            name: 'Steve Walker',
            image: '/assets/avatars/user-6.png',
            lastMessage: 'Admin-A.zip',
            time: '03:20 PM',
            unread: false
        }
    ];

    // Sample chat history data
    const chatHistory = [
        {
            date: 'March 7, 2025',
            conversations: [
                {
                    id: 1,
                    time: '10:00 AM',
                    messages: 5,
                    preview: 'Meeting about the new project...',
                    mediaCount: 2,
                    filesCount: 1
                },
                {
                    id: 2,
                    time: '02:30 PM',
                    messages: 12,
                    preview: 'Can you send me the designs?',
                    mediaCount: 3,
                    filesCount: 0
                }
            ]
        },
        {
            date: 'March 5, 2025',
            conversations: [
                {
                    id: 3,
                    time: '09:15 AM',
                    messages: 8,
                    preview: 'Good morning! Let\'s discuss the revisions...',
                    mediaCount: 0,
                    filesCount: 2
                }
            ]
        },
        {
            date: 'February 28, 2025',
            conversations: [
                {
                    id: 4,
                    time: '11:45 AM',
                    messages: 15,
                    preview: 'Here are the project files as requested.',
                    mediaCount: 0,
                    filesCount: 4
                },
                {
                    id: 5,
                    time: '03:20 PM',
                    messages: 7,
                    preview: 'Thanks for the feedback.',
                    mediaCount: 1,
                    filesCount: 1
                }
            ]
        },
        {
            date: 'February 25, 2025',
            conversations: [
                {
                    id: 6,
                    time: '10:30 AM',
                    messages: 10,
                    preview: 'Project kickoff meeting notes...',
                    mediaCount: 0,
                    filesCount: 2
                }
            ]
        }
    ];

    return (
        <Container fluid className="chat-container p-0">
            <div className="d-flex chat-wrapper">
                {/* Mini Sidebar - Always visible */}
                {/* <div className="mini-sidebar">
                    <div className="mini-sidebar-content">
                        <div className="app-logo">
                            <div className="logo-icon">JI</div>
                        </div>
                        <div className="nav-links">
                            <div className="nav-item">
                                <FaComment />
                            </div>
                            <div className="nav-item">
                                <FaUser />
                            </div>
                            <div className="nav-item">
                                <FaAddressBook />
                            </div>
                            <div className="nav-item">
                                <FaUsers />
                            </div>
                            <div className="nav-item active">
                                <FaHistory />
                            </div>
                            <div className="nav-item">
                                <FaGlobe />
                            </div>
                            <div className="nav-item">
                                <FaCog />
                            </div>
                        </div>
                        <div className="nav-bottom">
                            <div className="nav-item theme-toggle">
                                <FaMoon />
                            </div>
                        </div>
                    </div>
                </div> */}
                <GlobalMiniSidebar />

                {/* Main Content Area */}
                <div className="chat-main-container">
                    {/* Mobile Sidebar Overlay */}
                    {showSidebar && window.innerWidth < 768 && (
                        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
                    )}
                    
                    <div className="d-flex h-100 position-relative">
                        {/* Left Sidebar - Toggleable on mobile */}
                        <div 
                            ref={sidebarRef}
                            className={`chat-sidebar ${showSidebar ? 'show-sidebar' : 'hide-sidebar'}`}
                        >
                            {/* Mobile Close Button */}
                            <div className="d-md-none sidebar-close">
                                <button className="close-btn" onClick={toggleSidebar}>
                                    <FaTimes />
                                </button>
                            </div>
                            
                            {/* User Profile Header */}
                            <div className="sidebar-header d-flex align-items-center p-3">
                                <div className="user-avatar me-3">
                                    <Image src="/assets/avatars/user-1.png" alt="Your Profile" roundedCircle className="avatar" />
                                </div>
                                <div className="header-text">
                                    <h5 className="mb-0">Chats</h5>
                                </div>
                            </div>

                            {/* Search Bar */}
                            <div className="search-box p-3">
                                <InputGroup>
                                    <InputGroup.Text className="bg-light border-0">
                                        <FaSearch className="text-muted" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder="Search messages or users"
                                        className="border-0 bg-light"
                                    />
                                </InputGroup>
                            </div>

                            {/* Recent Chats */}
                            <div className="recent-section px-3 pt-2">
                                <h6 className="text-muted">Recent</h6>
                                <div className="recent-chats">
                                    {recentChats.map(chat => (
                                        <div
                                            key={chat.id}
                                            className={`chat-item d-flex align-items-center p-2 rounded ${activeContact === chat.name ? 'active' : ''}`}
                                            onClick={() => {
                                                setActiveContact(chat.name);
                                                if (window.innerWidth < 768) {
                                                    setShowSidebar(false);
                                                }
                                            }}
                                        >
                                            <div className="chat-avatar position-relative me-3">
                                                {chat.image ? (
                                                    <Image
                                                        src={chat.image}
                                                        alt={chat.name}
                                                        roundedCircle
                                                        className="avatar-md"
                                                    />
                                                ) : (
                                                    <div className="avatar-initial">{chat.initial}</div>
                                                )}
                                            </div>
                                            <div className="chat-details flex-grow-1">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h6 className="mb-0">{chat.name}</h6>
                                                    <span className="chat-time small text-muted">{chat.time}</span>
                                                </div>
                                                <p className="text-truncate mb-0 small">
                                                    {chat.lastMessage}
                                                </p>
                                            </div>
                                            {chat.unread && (
                                                <div className="unread-badge">
                                                    {chat.unreadCount || ''}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Main Chat History Area */}
                        <div className="chat-content-area">
                            {/* Header */}
                            <div className="chat-profile-header">
                                <Row className="align-items-center m-0">
                                    <Col xs="auto" className="d-md-none menu-toggle">
                                        <button 
                                            className="action-icon-btn me-2" 
                                            onClick={toggleSidebar}
                                            aria-label="Toggle sidebar"
                                        >
                                            <FaBars />
                                        </button>
                                    </Col>
                                    <Col className="d-flex align-items-center">
                                        <div className="profile-avatar me-3">
                                            <Image
                                                src="/assets/avatars/user-1.png"
                                                alt="Patrick Hendricks"
                                                roundedCircle
                                                className="profile-img"
                                            />
                                        </div>
                                        <div className="profile-info">
                                            <h4 className="mb-0 profile-name">Chat History</h4>
                                            <div className="online-status">
                                                <span className="text-muted">with</span> Patrick Hendricks
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs="auto" className="profile-actions">
                                        <div className="action-icons">
                                            <button className="action-icon-btn d-none d-sm-inline-block">
                                                <FaSearch />
                                            </button>
                                            <Dropdown>
                                                <Dropdown.Toggle as="button" className="action-icon-btn">
                                                    <FaFilter />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item onClick={() => setFilterDate('All time')}>All time</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setFilterDate('Last 7 days')}>Last 7 days</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setFilterDate('Last 30 days')}>Last 30 days</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setFilterDate('This month')}>This month</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setFilterDate('Last month')}>Last month</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <button className="action-icon-btn">
                                                <FaEllipsisH />
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Date Navigation */}
                            <div className="date-navigation p-3 d-flex justify-content-between align-items-center border-bottom">
                                <h5 className="mb-0">
                                    <FaCalendarAlt className="me-2" />
                                    {currentDateRange}
                                </h5>
                                <div>
                                    <Button variant="light" className="me-2" size="sm">
                                        <FaChevronLeft />
                                    </Button>
                                    <Button variant="light" size="sm">
                                        <FaChevronRight />
                                    </Button>
                                </div>
                            </div>

                            {/* Filter Indicator */}
                            <div className="filter-indicator px-3 py-2 bg-light border-bottom">
                                <Badge bg="primary" className="me-2">
                                    {filterDate} <span className="ms-1 cursor-pointer">×</span>
                                </Badge>
                                <span className="text-muted small">
                                    Showing conversation history for {filterDate.toLowerCase()}
                                </span>
                            </div>

                            {/* Chat History Content - With Scrolling */}
                            <div className="chat-history-content-wrapper">
                                <div className="chat-history-content p-3" ref={historyContainerRef}>
                                    {chatHistory.map((historyGroup, idx) => (
                                        <div key={idx} className="history-group mb-4">
                                            <div className="history-date mb-3">
                                                <h6 className="text-muted">{historyGroup.date}</h6>
                                            </div>
                                            
                                            {historyGroup.conversations.map(conversation => (
                                                <Card key={conversation.id} className="mb-3 shadow-sm">
                                                    <Card.Header className="bg-light d-flex justify-content-between align-items-center py-2">
                                                        <span className="fw-bold">{conversation.time}</span>
                                                        <span className="text-muted small">{conversation.messages} messages</span>
                                                    </Card.Header>
                                                    <Card.Body className="py-2">
                                                        <p className="mb-2">{conversation.preview}</p>
                                                        <div className="conversation-meta d-flex">
                                                            {conversation.mediaCount > 0 && (
                                                                <span className="me-3 text-muted small">
                                                                    <FaPaperclip className="me-1" />
                                                                    {conversation.mediaCount} media
                                                                </span>
                                                            )}
                                                            {conversation.filesCount > 0 && (
                                                                <span className="text-muted small">
                                                                    <FaDownload className="me-1" />
                                                                    {conversation.filesCount} files
                                                                </span>
                                                            )}
                                                        </div>
                                                    </Card.Body>
                                                    <Card.Footer className="bg-white border-top text-end py-2">
                                                        <Button variant="outline-primary" size="sm">
                                                            View Details
                                                        </Button>
                                                    </Card.Footer>
                                                </Card>
                                            ))}
                                        </div>
                                    ))}

                                    {/* Load More Button */}
                                    <div className="load-more text-center mb-3">
                                        <Button variant="light" className="w-50">
                                            Load More
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default ChatHistoryPage;